module.exports = __webpack_public_path__ + "img/logo-santarita.4a0773ea.png";